module.exports = __webpack_public_path__ + "static/tempus-symbol-SCAG-47215776aa4f8d26e58dd6a06af9f7b6.png";